define(
  'getPageToPush',[
    'searchTypeHelper'
  ],
  (
    searchTypeHelper
  ) => {
    'use strict';

    const functions = {
      CommunityResults: 'CommunityResults',
      CondoDevelopments: 'CondoDevelopments',
      HomeResults: 'HomeResults',
      CondoTownHomes: 'CondoTownHomes',
      BoylResults: 'CustomBoylBldrResults',
      CustomHomes: 'CustomBoylHomesResults',
      ManufacturedResults: 'ManufacturedResults',
      ManufacturedHomes: 'ManufacturedHomesResults',
    };

    function getNameToLog(url) {
      const functionSrp = searchTypeHelper.getSrpFunction(url);
      const srpType = searchTypeHelper.getSrpType(functionSrp);
      return functions[srpType] || url;
    }

    return {
      getNameToLog
    };
  }
);

